import { ContactDetails } from "../contact/contactDetails";
import LookupValue from "../patient-chart/lookupValue";

export default class Physician {
  id: number;
  contactId: number;
  firstName: string;
  lastName: string;
  mobile: string;
  fax: string;
  work: string;
  npi: string;
  address: ContactDetails = new ContactDetails();
  contactType: string;
  emailAddress: string;
  situationNotes: string;
  selectedCredential: string;
  relationType: LookupValue = new LookupValue();
  referralType: LookupValue = new LookupValue();
  referralCreditType: LookupValue = new LookupValue();

  static clone(cloner: Physician, contactType: string): Physician {
    let p = new Physician();

    p.id = cloner.id;
    p.contactId = cloner.contactId;
    p.firstName = cloner.firstName;
    p.lastName = cloner.lastName;
    p.mobile = cloner.mobile;
    p.work = cloner.work;
    p.fax = cloner.fax;
    p.npi = cloner.npi;
    p.address = cloner.address;
    p.contactType = contactType;
    p.emailAddress = cloner.emailAddress;
    p.selectedCredential = cloner.selectedCredential;
    p.situationNotes = cloner.situationNotes;
    p.relationType = cloner.relationType;
    p.referralType = cloner.referralType;
    p.referralCreditType = cloner.referralCreditType;

    return p;
  }

  static copyFrom(
    form: any,
    id: number,
    type: string,
    contactId: number
  ): Physician {
    console.log(form);
    let p = new Physician();

    p.id = id;
    p.npi = form.npi;
    p.address = new ContactDetails();
    p.address.address1 = form.address1;
    p.address.city = form.city;
    p.fax = form.fax;
    p.mobile = form.mobile;
    p.work = form.phone;
    p.address.zip = form.zip;
    p.address.county = form.county;
    p.address.state = form.state;
    p.firstName = form.firstName;
    p.lastName = form.lastName;
    p.contactId = contactId;
    p.contactType = type;
    p.emailAddress = form.email;
    p.situationNotes = form.notes;

    return p;
  }

  getFullName = (): string => {
    return this.firstName + " " + this.lastName;
  };

  isPhysician = (): boolean => {
    if (this.npi === "") {
      return false;
    }

    if (this.npi === undefined || this.npi === null) {
      return false;
    }

    return true;
  };

  hasRelationType = (): boolean => {
    if (this.relationType) {
      if (this.relationType.id && this.relationType.id > 0) {
        return true;
      }
    }

    return false;
  };

  hasReferrerType = (): boolean => {
    if (this.referralType) {
      if (this.referralType.id && this.referralType.id > 0) {
        return true;
      }
    }

    return false;
  };

  sameAs = (incoming: Physician): boolean => {
    if (!incoming) return false;
    return this.id === incoming.id;
  };
}



// WEBPACK FOOTER //
// ./src/models/resource-management/physician.ts